import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  container: {
    bg: "#fff", // change the backgroundColor of the container
    borderColor: "#DDD",
    _hover: {
      background: "black", // set background color to white on hover
      cursor: "pointer", // enable pointer events
    },
  },
});

export const accordionTheme = defineMultiStyleConfig({ baseStyle });
